import React, { useEffect, useState } from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';
import ProjectWork from './ProjectWork';
import intermediateTestService from '../services/intermediateTestService';

export default function IntermediateTestsPanel({ courseId }) {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    const loadIntermediateTests = async () => {
      setLoading(true);

      try {
        const data = await intermediateTestService.getIntermediateTests(courseId);

        if (!active) {
          return;
        }

        setItems(data.items || []);
        setError('');
      } catch {
        if (!active) {
          return;
        }

        setItems([]);
        setError('Impossibile caricare le prove intermedie.');
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadIntermediateTests();

    return () => {
      active = false;
    };
  }, [courseId]);

  if (loading) {
    return (
      <div className="bg-white rounded-xl p-8 shadow-lg flex items-center justify-center gap-3 text-gray-500">
        <Loader2 className="w-6 h-6 animate-spin" />
        Caricamento prove intermedie...
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700 flex gap-2">
        <AlertCircle className="w-4 h-4 flex-shrink-0 mt-0.5" />
        {error}
      </div>
    );
  }

  if (!items.length) {
    return null;
  }

  return (
    <div className="space-y-4">
      {items.map((item) => (
        <ProjectWork
          key={item.id}
          courseId={courseId}
          service={intermediateTestService}
          activityId={item.id}
          initialProjectWork={item}
          title="Prove Intermedie"
          emptyTitle="Nessuna prova intermedia attiva"
          emptyDescription="Il docente non ha ancora attivato le prove intermedie per questo corso."
          loadingLabel="Caricamento prove intermedie..."
          groupMissingLabel="Il docente non ti ha ancora assegnato a un gruppo per questa prova intermedia."
          sectionKey={`intermediate-tests-${item.id}`}
          hideWhenInactive
        />
      ))}
    </div>
  );
}
